/**
 * Authentication Endpoints
 * COMMON: Used by both HubAdmin and SuperAdmin
 */
export const AUTH_ENDPOINTS = {
  login: 'login/login',
  logout: 'login/logout',
  updateProgram: 'login/update-program',
  refreshToken: 'login/refresh-token',
  forgotPassword: 'login/forgot-password',
  resetPassword: 'login/reset-password',
};
